import React, { useContext } from "react";
import HeaderMenuItem from "./HeaderMenuItem";
import FlexRow from "./FlexRow";
import InBetweenSpacing from "./InBetweenSpacing";
import MenuItem from "./MenuItem";
import WhitelabelContext from "../components/WhitelabelContext";

function HeaderMenu() {
  const whitelabelContext = useContext(WhitelabelContext);

  const handleLogout = () => {
    sessionStorage.clear();
    if (whitelabelContext.isSsoOnly("STUDENT")) {
      window.location.href = whitelabelContext.getSsoRedirectUrl("STUDENT");
    } else {
      window.location.reload();
    }
  };

  return (
    <FlexRow alignItems="center" justifyContent="space-between">
      <InBetweenSpacing size="sm">
        <HeaderMenuItem>
          <MenuItem icon="logout" link="/" label="menu.logout" onClick={handleLogout} />
        </HeaderMenuItem>
      </InBetweenSpacing>
    </FlexRow>
  );
}

export default HeaderMenu;
